import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { sortData, toPercent } from './../../addComas'
import { db } from './../../Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';


const useStyles = makeStyles({
    table: {

    },
});


export default function Tabla() {
    const classes = useStyles();
    const [Data, setData] = useState(null)
    const [fecha, setFecha] = useState(null)
    //Get DATA from firebase
    useEffect(() => {
        db.collection('Pruebas').doc('INV')
            .collection('PAISES').doc('data')
            .onSnapshot(snapshot => {
                setData(sortData(snapshot.data()))
            });
        //Cargar fecha actualización
        db.collection('Pruebas').doc('INV')
            .onSnapshot(snapshot => {
                setFecha(snapshot.data()['Fecha'])
            });
    }, [])

    return (
        <div className='inv-table-container'>


            <h3 >
                Principales Paises Inversionistas {fecha && fecha}

            </h3>
            {Data ? (
                <TableContainer component={Paper} >
                    <Table size="small" aria-label="a dense table" className={classes.table} >
                        <TableHead >
                            <TableRow>
                                <TableCell style={{ fontWeight: 700 }}>País</TableCell>
                                <TableCell align="right">Inversión</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {
                                Object.keys(Data).map((key) => (
                                    <TableRow key={key} >
                                        <TableCell component="th" scope="row" style={{ fontWeight: 700 }}>
                                            {key}
                                        </TableCell>
                                        <TableCell align="right">{toPercent(Data[key])}</TableCell>

                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>

            ) : (
                    <CircularProgress style={{ color: 'green' }} />
                )}
        </div>
    );
}
